import React, { useState } from "react";
import dayjs from "dayjs";
import { LineBoxContainer } from "../../../pages/UserLog/UserLog";
import CalendarLineBtn from "../../Button/CalendarLineBtn";
import ConfirmBtn from "../../Button/ConfirmBtn";
import LineBtn from "../../Button/LineBtn";
import Flex from "../../DefaultStyles/Flex";
import CalendarModal from "../../Modal/CalendarModal";
import { CalendarLine } from "../Party/ChatInfo/ChatSearch/RecentChat";

interface DashBoardDateFilterProps {
  filter: {
    startDate: string;
    endDate: string;
  };
  setFilter: any;

  isAfter?: {
    value: number;
    unit: string;
  };
}

export default function DashBoardDateFilter({
  filter,
  setFilter,

  isAfter,
}: DashBoardDateFilterProps) {
  const [startDate, setStartDate] = useState(
    filter?.startDate !== "" ? filter?.startDate : ""
  );
  const [startDateClick, setStartDateClick] = useState(false);

  const [endDate, setEndDate] = useState(
    filter?.endDate !== "" ? filter?.endDate : ""
  );
  const [endDateClick, setEndDateClick] = useState(false);

  return (
    <Flex gapSize={10}>
      <LineBoxContainer>
        <CalendarLineBtn
          onClickEvent={() => setStartDateClick(true)}
          value={startDate}
          initValue={"날짜 선택"}
        />

        {startDateClick && (
          <CalendarModal
            closeEvent={() => setStartDateClick(false)}
            changeEvent={(date: string) => setStartDate(date)}
            sPosition="absolute"
            isFutureDisableFromToday={true}
          />
        )}
      </LineBoxContainer>

      <CalendarLine />

      <LineBoxContainer>
        <CalendarLineBtn
          onClickEvent={() => setEndDateClick(true)}
          value={endDate}
          initValue={"날짜 선택"}
          disabled={startDate === "날짜 선택"}
        />

        {endDateClick && (
          <CalendarModal
            closeEvent={() => setEndDateClick(false)}
            changeEvent={(date: string) => setEndDate(date)}
            sPosition="absolute"
            dateValue={startDate}
            isTodayDisable={true}
            isAfter={isAfter}
          />
        )}
      </LineBoxContainer>

      <ConfirmBtn
        btnColor="mint"
        btnText="적용"
        btnHeight={38}
        isDisabled={startDate === "날짜 선택" || endDate === "날짜 선택"}
        btnClickEvent={() => {
          setFilter({
            ...filter,
            startDate: dayjs(startDate)?.format("YYYY-MM-DD"),
            endDate: dayjs(endDate)?.format("YYYY-MM-DD"),
          });
        }}
      />

      <LineBtn
        btnColor="mint"
        btnText="초기화"
        icon="refresh"
        btnHeight={38}
        disabled={startDate === "날짜 선택" && endDate === "날짜 선택"}
        btnClickEvent={() => {
          setFilter({
            ...filter,
            startDate: dayjs().add(-7, "day")?.format("YYYY-MM-DD"),
            endDate: dayjs().add(-1, "day")?.format("YYYY-MM-DD"),
          });
          setStartDate(dayjs().add(-7, "day")?.format("YYYY-MM-DD"));
          setEndDate(dayjs().add(-1, "day")?.format("YYYY-MM-DD"));
        }}
      />
    </Flex>
  );
}
